<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6273)">
<g clip-path="url(#clip1_2229_6273)">
<rect x="7.75" y="14.5" width="5" height="1" rx="0.5" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M36.5 15C36.5 11.134 33.366 8 29.5 8H23.5C19.634 8 16.5 11.134 16.5 15C16.5 18.866 19.634 22 23.5 22H29.5C33.366 22 36.5 18.866 36.5 15ZM23.5385 14.4616C23.2411 14.4616 23 14.7026 23 15C23 15.2974 23.2411 15.5385 23.5385 15.5385H27.4615C27.7589 15.5385 28 15.2974 28 15C28 14.7026 27.7589 14.4616 27.4615 14.4616H23.5385Z" fill="currentColor"/>
</g>
<rect x="2.2" y="8.7" width="33.6" height="12.6" rx="6.3" stroke="currentColor" stroke-width="1.4"/>
</g>
<defs>
<clipPath id="clip0_2229_6273">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
<clipPath id="clip1_2229_6273">
<rect x="1.5" y="8" width="35" height="14" rx="7" fill="white"/>
</clipPath>
</defs>
</svg>
